import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  Box, Button, Paper, Stack, Typography, Chip,
  Table, TableBody, TableCell, TableHead, TableRow, IconButton,
} from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import BlockIcon from "@mui/icons-material/Block";
import Swal from "sweetalert2";
import { listarFormularios, excluirFormulario } from "../../services/formularioService";

export default function FormularioList() {
  const navigate = useNavigate();
  const [forms, setForms] = useState([]);

  const carregar = async () => {
    try {
      const { data } = await listarFormularios();
      setForms(data);
    } catch (e) {
      Swal.fire("Erro", e?.response?.data || e.message, "error");
    }
  };

  useEffect(() => { carregar(); }, []);

  const inativar = async (id) => {
    const r = await Swal.fire({
      title: "Inativar formulário?",
      text: "Fichas já vinculadas continuam válidas; o formulário deixa de aparecer para novas edições.",
      icon: "warning", showCancelButton: true,
      confirmButtonText: "Inativar", cancelButtonText: "Cancelar",
    });
    if (!r.isConfirmed) return;
    await excluirFormulario(id);
    carregar();
  };

  return (
    <Box>
      <Stack direction="row" justifyContent="space-between" alignItems="center" mb={2}>
        <Typography variant="h5">Formulários</Typography>
        <Button variant="contained" onClick={() => navigate("/formularios/novo")}>
          Novo formulário
        </Button>
      </Stack>

      <Paper>
        <Table size="small">
          <TableHead>
            <TableRow>
              <TableCell>ID</TableCell>
              <TableCell>Nome</TableCell>
              <TableCell align="center">Versão</TableCell>
              <TableCell align="center">Perguntas</TableCell>
              <TableCell align="center">Status</TableCell>
              <TableCell align="center">Ações</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {forms.map((f) => (
              <TableRow key={f.Id} hover>
                <TableCell>{f.Id}</TableCell>
                <TableCell>{f.Nome}</TableCell>
                <TableCell align="center">{f.Versao}</TableCell>
                <TableCell align="center">{f.QtdPerguntas}</TableCell>
                <TableCell align="center">
                  <Chip size="small" label={f.Ativo ? "Ativo" : "Inativo"}
                    color={f.Ativo ? "success" : "default"} />
                </TableCell>
                <TableCell align="center">
                  <IconButton size="small" onClick={() => navigate(`/formularios/${f.Id}`)}>
                    <EditIcon fontSize="small" />
                  </IconButton>
                  {f.Ativo && (
                    <IconButton size="small" color="error" onClick={() => inativar(f.Id)}>
                      <BlockIcon fontSize="small" />
                    </IconButton>
                  )}
                </TableCell>
              </TableRow>
            ))}
            {forms.length === 0 && (
              <TableRow><TableCell colSpan={6} align="center">Nenhum formulário.</TableCell></TableRow>
            )}
          </TableBody>
        </Table>
      </Paper>
    </Box>
  );
}
